import { render, staticRenderFns } from "./MFA.vue?vue&type=template&id=51bdc88b&scoped=true&"
import script from "./MFA.vue?vue&type=script&lang=js&"
export * from "./MFA.vue?vue&type=script&lang=js&"
import style0 from "./MFA.vue?vue&type=style&index=0&id=51bdc88b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bdc88b",
  null
  
)

export default component.exports